import { validation } from './validation';
import {_global} from './global';
import {history} from './history';
import {authHeader} from './auth-header';

export function preferredNetworkCodesQueryParams(memberDetail) {
  if (!memberDetail) return {}

  const raw =
    memberDetail.plan?.networkConfigs?.preferredNetworkCodes ??
    memberDetail.networks?.configs?.preferredNetworkCodes

  if (!raw) return {}

  const str = Array.isArray(raw)
    ? raw.map(String).join(',')
    : String(raw).trim()

  if (str === '') return {}
  
  return { preferredNetworkCodes: encodeURIComponent(str) }
}

export {
    _global,
    history,
    authHeader,
    validation
}
